import { styled } from "styled-components";

export const PaymentBackColor = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #383838;
  color: #fff;
  border-radius: 20px;
  height: 30px;
  padding: 0 12px 0 12px;
`;
